export const sizes = {
  gutter: 24,

  maxWidthSm: 600,
  maxWidthMd: 768,
  maxWidth: 900,
  maxWidthWeb: 1824,

  radiusSm: 4,
  radius: 11,
  radiusMd: 11,
  radiusLg: 22,
  radiusCircle: 9999,

  xxs: 4,
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48,
  xxxl: 56,

  // Web layout constants (no theme spacing equivalent)
  webSidebarWidth: 330,
  webHeaderHeight: 84,
  webLayoutBreakpoint: 800,

  // Camera card dimensions (no theme spacing equivalent)
  cameraCardImageHeight: 196,
  /**
   * Narrowest a camera card may get before its snapshot and label row start to
   * look cramped. The web grid fits as many columns as will stay above this.
   */
  cameraCardMinWidth: 280,

  // Web camera details page constants (no theme spacing equivalent)
  webContentMaxWidth: 784,
  /**
   * Max content width for full-page reports (e.g. WasteSense). Wider
   * than `webContentMaxWidth` because reports embed wide tables and
   * trend charts; matches the static report templates.
   */
  webReportMaxWidth: 1040,
  webCardHeight: 202,
  webSnapshotHeight: 346,
  webRightPanelWidth: 320,
  /** Narrowest a scenario card may get before its three text lines wrap awkwardly. */
  scenarioCardMinWidth: 320,
  webRightPanelCardMinHeight: 90,
  webDatePickerHeight: 44,

  // Web drawer (overlay) constants
  webDrawerWidth: 380,
} as const;
